import { graphql } from '../__generated__/gql';

export const GET_ALL_PURCHASE_ORDERS = graphql(/* GraphQL */ `
  query PurchaseOrders($assetId: Int!) {
    allPurchaseOrders(assetId: $assetId) {
      purchaseOrderId
      poNumber
      assetId
      vendor
      type
      status
      comments
      updatedBy
      updatedAt
      tarJobs {
        jobId
      }
    }
  }
`);
export const GET_JOB_PURCHASE_ORDER = graphql(/* GraphQL */ `
  query JobPurchaseOrders($jobId: Int!) {
    purchaseOrdersByJobId(jobId: $jobId) {
      purchaseOrderId
      poNumber
      assetId
      vendor
      type
      status
      comments
      updatedBy
      updatedAt
      tarJobs {
        jobId
      }
    }
  }
`);
export const CREATE_PURCHASE_ORDER = graphql(/* GraphQL */ `
  mutation CreatePurchaseOrder($input: PurchaseOrderInput!) {
    createPurchaseOrder(input: $input) {
      purchaseOrderId
    }
  }
`);

export const UPDATE_PURCHASE_ORDER = graphql(/* GraphQL */ `
  mutation UpdatePurchaseOrder($input: PurchaseOrderInput!) {
    updatePurchaseOrder(input: $input) {
      purchaseOrderId
    }
  }
`);

export const LINK_PURCHASE_ORDER_JOBS = graphql(/* GraphQL */ `
  mutation LinkPurchaseOrderJobs($purchaseOrderId: Int!, $jobIds: [Int]!) {
    linkPurchaseOrderJobs(purchaseOrderId: $purchaseOrderId, jobIds: $jobIds) {
      purchaseOrderId
    }
  }
`);

export const REMOVE_PURCHASE_ORDER = graphql(/* GraphQL */ `
  mutation RemovePurchaseOrder($purchaseOrderId: Int!) {
    removePurchaseOrder(purchaseOrderId: $purchaseOrderId)
  }
`);
